import * as React from 'react';
import Snackbar from '@mui/material/Snackbar';
import { Alert } from '@mui/material';

export default function SnackbarWithMessage({ open, onClose, message, severity = "info", vertical = "bottom", horizontal = "right" }) {
  return (
    <div>
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={open}
        onClose={onClose}
        autoHideDuration={3000}
        key={`Snackbar-bottom-right_${message}_${severity}`}
      >
        <Alert severity={severity} onClose={onClose} sx={{ width: '100%' }}>{message}</Alert>
      </Snackbar>
    </div>
  );
}